module.exports = __webpack_public_path__ + "static/media/pc_icon_more.1571a17e.svg";